(() => {
  const toastRegion = document.querySelector('[data-toast-region]');
  let lastFocus = null;
  let sizeGuideLastFocus = null;
  const money = cents => new Intl.NumberFormat(document.documentElement.lang || 'sl-SI', { style: 'currency', currency: document.body.dataset.currency || 'EUR' }).format(cents / 100);
  const toast = message => { if (!toastRegion) return; toastRegion.textContent = message; toastRegion.classList.add('show'); clearTimeout(window.__jToast); window.__jToast = setTimeout(() => toastRegion.classList.remove('show'), 2400); };
  const closeDrawers = () => {
    document.querySelectorAll('[data-drawer].open').forEach(drawer => { drawer.classList.remove('open'); drawer.setAttribute('aria-hidden', 'true'); });
    document.querySelector('[data-drawer-scrim]')?.classList.remove('open');
    document.body.style.overflow = '';
    document.querySelectorAll('[data-drawer-open]').forEach(button => button.setAttribute('aria-expanded', 'false'));
    if (lastFocus?.isConnected) lastFocus.focus();
  };
  const openDrawer = (name, focusTarget = '') => {
    closeDrawers(); const drawer = document.querySelector(`[data-drawer="${name}"]`); if (!drawer) return;
    lastFocus = document.activeElement; drawer.classList.add('open'); drawer.setAttribute('aria-hidden', 'false');
    document.querySelector('[data-drawer-scrim]')?.classList.add('open'); document.body.style.overflow = 'hidden';
    document.querySelector(`[data-drawer-open="${name}"]`)?.setAttribute('aria-expanded', 'true');
    requestAnimationFrame(() => {
      if (name === 'filters' && focusTarget === 'size') {
        const sizeGroup = [...drawer.querySelectorAll('[data-filter-group]')].find(group => /velikost|size|stevil|števil/.test(group.dataset.filterGroup || ''));
        if (sizeGroup) {
          sizeGroup.open = true;
          sizeGroup.scrollIntoView({ block: 'start', behavior: 'smooth' });
          window.setTimeout(() => sizeGroup.querySelector('input:not(:disabled),button:not(:disabled),select:not(:disabled)')?.focus(), 320);
          return;
        }
      }
      drawer.querySelector('button,a,input,select')?.focus();
    });
  };
  const megaMenu = document.querySelector('.mega-menu');
  const megaScrim = document.querySelector('.mega-scrim');
  const closeMega = () => {
    if (!megaMenu) return;
    megaMenu.classList.remove('open');
    megaMenu.setAttribute('aria-hidden', 'true');
    megaScrim?.classList.remove('open');
    document.querySelectorAll('[data-mega]').forEach(button => {
      button.classList.remove('active');
      button.setAttribute('aria-expanded', 'false');
    });
    document.querySelectorAll('[data-mega-panel]').forEach(panel => panel.classList.remove('active'));
  };
  const openMega = name => {
    const trigger = document.querySelector(`[data-mega="${name}"]`);
    const panel = document.querySelector(`[data-mega-panel="${name}"]`);
    if (!megaMenu || !trigger || !panel) return;
    closeMega();
    trigger.classList.add('active');
    trigger.setAttribute('aria-expanded', 'true');
    panel.classList.add('active');
    megaMenu.classList.add('open');
    megaMenu.setAttribute('aria-hidden', 'false');
    megaScrim?.classList.add('open');
  };
  document.querySelectorAll('[data-mega]').forEach(trigger => {
    trigger.addEventListener('mouseenter', () => {
      if (matchMedia('(min-width: 760px) and (hover: hover)').matches && !trigger.classList.contains('active')) openMega(trigger.dataset.mega);
    });
  });
  const warmGallerySlide = (slide, priority = 'low') => {
    const image = slide?.querySelector('img');
    if (!image || image.complete) return;
    image.loading = 'eager';
    image.fetchPriority = priority;
  };
  const showGallery = (product, index) => {
    const slides = [...product.querySelectorAll('[data-gallery-slide]')];
    if (!slides.length) return;
    index = (index + slides.length) % slides.length;
    warmGallerySlide(slides[index], 'high');
    slides.forEach((slide, i) => {
      slide.classList.toggle('active', i === index);
      slide.setAttribute('aria-hidden', String(i !== index));
      if (i !== index) slide.querySelectorAll('video').forEach(video => video.pause());
    });
    product.querySelectorAll('[data-gallery-thumb]').forEach(thumb => {
      const active = thumb.dataset.galleryId === slides[index].dataset.gallerySlide;
      thumb.classList.toggle('active', active);
      thumb.setAttribute('aria-pressed', String(active));
    });
    const count = product.querySelector('[data-gallery-current]');
    if (count) count.textContent = index + 1;
  };
  const stepGallery = (product, step) => {
    const slides = [...product.querySelectorAll('[data-gallery-slide]')];
    showGallery(product, Math.max(0, slides.findIndex(slide => slide.classList.contains('active'))) + step);
  };
  const updateProductOptionAvailability = product => {
    const groups = [...product.querySelectorAll('[data-option-position]')];
    if (!groups.length) return;
    const variants = JSON.parse(product.dataset.productJson || '[]');
    const selected = groups.map(group => group.querySelector('[data-option-button].active')?.dataset.optionValue || '');
    groups.forEach((group, groupIndex) => {
      group.querySelectorAll('[data-option-button]').forEach(button => {
        const optionValue = button.dataset.optionValue || '';
        const possible = variants.some(variant => {
          if (!variant.available || variant.options[groupIndex] !== optionValue) return false;
          if (group.dataset.optionKind === 'color') return true;
          return groups.every((otherGroup, otherIndex) => otherGroup.dataset.optionKind !== 'color' || variant.options[otherIndex] === selected[otherIndex]);
        });
        button.disabled = !possible;
        button.classList.toggle('unavailable', !possible);
        button.setAttribute('aria-disabled', String(!possible));
      });
    });
  };
  const updateBeautyQuantityOffer = product => {
    const offer = product.querySelector('[data-beauty-quantity-offer]');
    if (!offer) return;
    const active = offer.querySelector('[data-beauty-quantity-choice].active') || offer.querySelector('[data-beauty-quantity-choice]');
    const quantity = Math.max(1, Number(active?.dataset.beautyQuantityChoice || 1));
    const discount = Math.max(0, Number(active?.dataset.beautyDiscount || 0));
    const quantityInput = offer.querySelector('[data-product-quantity]');
    if (quantityInput) quantityInput.value = quantity;
    const variants = JSON.parse(product.dataset.productJson || '[]');
    const variantId = product.querySelector('[data-variant-select]')?.value;
    const variant = variants.find(item => String(item.id) === String(variantId));
    const add = product.querySelector('[data-add-to-cart]');
    const addPrice = product.querySelector('[data-add-price]');
    if (variant && addPrice) addPrice.textContent = money(Math.round(variant.price * quantity * (100 - discount) / 100));
    if (add && variant?.available) add.querySelector('span').textContent = quantity === 1 ? 'DODAJ V KOŠARICO' : `DODAJ ${quantity} ${quantity === 2 ? 'KOSA' : 'KOSE'} V KOŠARICO`;
  };
  const selectProductVariant = (product, variant) => {
    const groups = [...product.querySelectorAll('[data-option-position]')];
    groups.forEach((group, index) => {
      const value = variant.options[index];
      group.querySelectorAll('[data-option-button]').forEach(button => {
        const active = button.dataset.optionValue === value;
        button.classList.toggle('active', active);
        button.setAttribute('aria-pressed', String(active));
      });
      const current = group.querySelector('legend [data-option-value]');
      if (current) current.textContent = value;
    });
    const select = product.querySelector('[data-variant-select]');
    const add = product.querySelector('[data-add-to-cart]');
    if (select) select.value = variant.id;
    const url = new URL(location.href);
    url.searchParams.set('variant', variant.id);
    history.replaceState({}, '', url);
    const compare = product.querySelector('[data-compare-price]');
    if (compare) {
      compare.hidden = !(variant.compare_at_price > variant.price);
      compare.textContent = money(variant.compare_at_price || 0);
    }
    const priceValue = product.querySelector('[data-product-price-value]');
    if (priceValue) priceValue.textContent = money(variant.price);
    const addPrice = product.querySelector('[data-add-price]');
    if (addPrice) addPrice.textContent = money(variant.price);
    if (add) {
      add.disabled = !variant.available;
      add.querySelector('span').textContent = variant.available ? 'DODAJ V KOŠARICO' : 'RAZPRODANO';
    }
    updateBeautyQuantityOffer(product);
    if (variant.featured_media) product.querySelector(`[data-gallery-thumb][data-gallery-id="${variant.featured_media.id}"]`)?.click();
    updateProductOptionAvailability(product);
  };
  document.querySelectorAll('[data-product-root]').forEach(product => {
    const slides = [...product.querySelectorAll('[data-gallery-slide]')];
    showGallery(product, Math.max(0, slides.findIndex(slide => slide.classList.contains('active'))));
    const warmNearbySlides = () => {
      const activeIndex = Math.max(0, slides.findIndex(slide => slide.classList.contains('active')));
      warmGallerySlide(slides[(activeIndex + 1) % slides.length]);
      if (slides.length > 2) warmGallerySlide(slides[(activeIndex - 1 + slides.length) % slides.length]);
    };
    product.querySelectorAll('[data-gallery-thumb]').forEach(thumb => {
      const warmThumbTarget = () => warmGallerySlide(slides.find(slide => slide.dataset.gallerySlide === thumb.dataset.galleryId), 'high');
      thumb.addEventListener('pointerenter', warmThumbTarget, { once: true });
      thumb.addEventListener('focus', warmThumbTarget, { once: true });
      thumb.addEventListener('touchstart', warmThumbTarget, { once: true, passive: true });
    });
    const gallery = product.querySelector('[data-product-gallery]');
    let start = null;
    gallery?.addEventListener('touchstart', event => {
      if (event.touches.length === 1 && !event.target.closest('button,video,iframe')) {
        warmNearbySlides();
        start = { x: event.touches[0].clientX, y: event.touches[0].clientY };
      }
    }, { passive: true });
    gallery?.addEventListener('touchend', event => {
      if (!start || !event.changedTouches.length) return;
      const dx = event.changedTouches[0].clientX - start.x;
      const dy = event.changedTouches[0].clientY - start.y;
      start = null;
      if (Math.abs(dx) > 45 && Math.abs(dx) > Math.abs(dy) * 1.3) stepGallery(product, dx < 0 ? 1 : -1);
    }, { passive: true });
    gallery?.addEventListener('touchcancel', () => { start = null; }, { passive: true });
    gallery?.querySelectorAll('[data-gallery-step]').forEach(button => button.addEventListener('pointerdown', warmNearbySlides, { passive: true }));
    updateProductOptionAvailability(product);
    updateBeautyQuantityOffer(product);
  });
  const replaceCart = html => {
    if (!html) return; const doc = new DOMParser().parseFromString(html, 'text/html'); const fresh = doc.querySelector('[data-cart-drawer-section]'); const current = document.querySelector('[data-cart-drawer-section]'); if (fresh && current) { const wasOpen=current.classList.contains('open'); current.replaceWith(fresh); if(wasOpen){fresh.classList.add('open');fresh.setAttribute('aria-hidden','false');} }
  };
  const refreshCartCount = async () => { const cart = await fetch(`${window.Shopify?.routes?.root || '/'}cart.js`).then(r => r.json()); document.querySelectorAll('[data-cart-count]').forEach(node => node.textContent = cart.item_count); return cart; };
  const updateCartLine = async (line, quantity) => {
    const response = await fetch(`${window.Shopify?.routes?.root || '/'}cart/change.js`, { method:'POST', headers:{'Content-Type':'application/json','Accept':'application/json'}, body:JSON.stringify({line,quantity,sections:'cart-drawer',sections_url:location.pathname}) });
    const data = await response.json(); if (!response.ok) throw new Error(data.description || 'Košarice ni bilo mogoče posodobiti.'); replaceCart(data.sections?.['cart-drawer']); await refreshCartCount();
  };
  let collectionLoadPromise = null;
  const loadAllCollectionProducts = () => {
    if (collectionLoadPromise) return collectionLoadPromise;
    const grid = document.querySelector('.collection-grid');
    const pagination = document.querySelector('.pagination');
    if (!grid || !pagination) return Promise.resolve();
    const pages = [...pagination.querySelectorAll('a[href*="page="]')].map(link => Number(new URL(link.href, location.href).searchParams.get('page')) || 1);
    const lastPage = Math.max(1, ...pages);
    const currentPage = Number(new URL(location.href).searchParams.get('page')) || 1;
    collectionLoadPromise = Promise.all(Array.from({ length: lastPage }, (_, index) => index + 1).filter(page => page !== currentPage).map(async page => {
      const url = new URL(location.href); url.searchParams.set('page', page);
      const html = await fetch(url).then(response => { if (!response.ok) throw new Error('Izdelkov ni bilo mogoče naložiti.'); return response.text(); });
      const doc = new DOMParser().parseFromString(html, 'text/html');
      return [...doc.querySelectorAll('.collection-grid .product-card')];
    })).then(groups => {
      groups.flat().forEach(card => grid.append(card));
      pagination.hidden = true;
    }).catch(error => toast(error.message));
    return collectionLoadPromise;
  };
  document.addEventListener('click', async event => {
    const productBack = event.target.closest('[data-page-back]');
    if (productBack && document.referrer) {
      const previous = new URL(document.referrer, location.href);
      if (previous.origin === location.origin) { event.preventDefault(); history.back(); return; }
    }
    const megaTrigger = event.target.closest('[data-mega]');
    if (megaTrigger) { event.preventDefault(); openMega(megaTrigger.dataset.mega); return; }
    if (event.target.matches('.mega-scrim')) { event.preventDefault(); closeMega(); return; }
    const sizeGuideOpen = event.target.closest('[data-size-guide-open]');
    if (sizeGuideOpen) {
      event.preventDefault();
      const dialog = sizeGuideOpen.closest('[data-product-root]')?.querySelector('[data-size-guide-dialog]');
      if (dialog) {
        sizeGuideLastFocus = sizeGuideOpen;
        dialog.showModal();
        document.body.style.overflow = 'hidden';
        requestAnimationFrame(() => dialog.querySelector('[data-size-guide-close]')?.focus());
      }
      return;
    }
    const sizeGuideClose = event.target.closest('[data-size-guide-close]');
    if (sizeGuideClose) { event.preventDefault(); sizeGuideClose.closest('[data-size-guide-dialog]')?.close(); return; }
    if (event.target.matches('[data-size-guide-dialog]')) { event.target.close(); return; }
    const open = event.target.closest('[data-drawer-open]'); if (open) { event.preventDefault(); openDrawer(open.dataset.drawerOpen, open.dataset.filterFocus || ''); return; }
    if (event.target.closest('[data-drawer-close]') || event.target.matches('[data-drawer-scrim]')) { event.preventDefault(); closeDrawers(); return; }
    const customFilterChoice = event.target.closest('[data-color-filter-value],[data-category-filter-value]');
    if (customFilterChoice) {
      event.preventDefault();
      const isColor = customFilterChoice.hasAttribute('data-color-filter-value');
      const attribute = isColor ? 'data-color-filter-value' : 'data-category-filter-value';
      const selectedValue = (customFilterChoice.getAttribute(attribute) || '').trim();
      const datasetKey = isColor ? 'collectionColorFilter' : 'collectionCategoryFilter';
      const selections = new Set((document.body.dataset[datasetKey] || '').split('||').filter(Boolean));
      if (!selectedValue) selections.clear();
      else if (selections.has(selectedValue)) selections.delete(selectedValue);
      else selections.add(selectedValue);
      document.body.dataset[datasetKey] = [...selections].join('||');
      customFilterChoice.closest('[data-quick-color-filter],[data-quick-category-filter]')?.querySelectorAll(`[${attribute}]`).forEach(button => {
        const value = (button.getAttribute(attribute) || '').trim();
        const active = value ? selections.has(value) : selections.size === 0;
        button.classList.toggle('active', active);
        button.setAttribute('aria-pressed', String(active));
      });
      if (selections.size) await loadAllCollectionProducts();
      document.querySelector('[data-collection-search]')?.dispatchEvent(new Event('input', { bubbles: true }));
      toast(selections.size ? `Izbranih možnosti: ${selections.size}.` : `Prikazujem vse ${isColor ? 'barve' : 'kategorije'}.`);
      return;
    }
    const sizeChoice = event.target.closest('[data-size-filter-value]');
    if (sizeChoice) {
      event.preventDefault();
      const selectedSize = (sizeChoice.dataset.sizeFilterValue || '').trim();
      const selections = new Set((document.body.dataset.collectionSizeFilter || '').split('||').filter(Boolean));
      if (!selectedSize) selections.clear();
      else if (selections.has(selectedSize)) selections.delete(selectedSize);
      else selections.add(selectedSize);
      document.body.dataset.collectionSizeFilter = [...selections].join('||');
      document.querySelectorAll('[data-size-filter-value]').forEach(button => {
        const value = (button.dataset.sizeFilterValue || '').trim();
        const active = value ? selections.has(value) : selections.size === 0;
        button.classList.toggle('active', active);
        button.setAttribute('aria-pressed', String(active));
      });
      if (selections.size) await loadAllCollectionProducts();
      document.querySelector('[data-collection-search]')?.dispatchEvent(new Event('input', { bubbles: true }));
      toast(selections.size ? `Izbranih velikosti: ${selections.size}.` : 'Prikazujem vse velikosti.');
      return;
    }
    const galleryStep = event.target.closest('[data-gallery-step]');
    if (galleryStep) { stepGallery(galleryStep.closest('[data-product-root]'), Number(galleryStep.dataset.galleryStep)); return; }
    const thumb = event.target.closest('[data-gallery-thumb]');
    if (thumb) {
      const product = thumb.closest('[data-product-root]');
      showGallery(product, [...product.querySelectorAll('[data-gallery-slide]')].findIndex(slide => slide.dataset.gallerySlide === thumb.dataset.galleryId));
      return;
    }
    const beautyQuantityChoice = event.target.closest('[data-beauty-quantity-choice]');
    if (beautyQuantityChoice) {
      event.preventDefault();
      const product = beautyQuantityChoice.closest('[data-product-root]');
      const offer = beautyQuantityChoice.closest('[data-beauty-quantity-offer]');
      offer.querySelectorAll('[data-beauty-quantity-choice]').forEach(button => {
        const active = button === beautyQuantityChoice;
        button.classList.toggle('active', active);
        button.setAttribute('aria-pressed', String(active));
      });
      updateBeautyQuantityOffer(product);
      return;
    }
    const option = event.target.closest('[data-option-button]'); if (option) {
      if (option.disabled) return;
      const product = option.closest('[data-product-root]');
      const group = option.closest('[data-option-position]');
      const groups = [...product.querySelectorAll('[data-option-position]')];
      group.querySelectorAll('[data-option-button]').forEach(el => { el.classList.toggle('active', el === option); el.setAttribute('aria-pressed', String(el === option)); });
      group.querySelector('legend [data-option-value]').textContent = option.dataset.optionValue;
      const choices = groups.map(el => el.querySelector('[data-option-button].active')?.dataset.optionValue || '');
      const variants = JSON.parse(product.dataset.productJson || '[]');
      const groupIndex = groups.indexOf(group);
      const exactVariant = variants.find(item => item.options.every((value,index) => value === choices[index]));
      const variant = exactVariant?.available ? exactVariant : variants.find(item => item.available && item.options[groupIndex] === option.dataset.optionValue);
      if (variant) selectProductVariant(product, variant);
      else {
        const select = product.querySelector('[data-variant-select]');
        const add = product.querySelector('[data-add-to-cart]');
        if (select) select.value = '';
        if (add) { add.disabled = true; add.querySelector('span').textContent = 'NI NA VOLJO'; }
        updateProductOptionAvailability(product);
      }
      return;
    }
    const wishlist = event.target.closest('[data-wishlist-toggle]'); if (wishlist) { event.preventDefault(); const key='josephine-wishlist'; const saved=new Set(JSON.parse(localStorage.getItem(key)||'[]')); saved.has(wishlist.dataset.productHandle)?saved.delete(wishlist.dataset.productHandle):saved.add(wishlist.dataset.productHandle); const isSaved=saved.has(wishlist.dataset.productHandle); localStorage.setItem(key,JSON.stringify([...saved])); wishlist.textContent=isSaved?'♥':'♡'; wishlist.classList.toggle('saved',isSaved); wishlist.setAttribute('aria-pressed',String(isSaved)); toast(isSaved?'Izdelek je shranjen med priljubljene.':'Izdelek je odstranjen iz priljubljenih.'); return; }
    const cartPageStep = event.target.closest('[data-cart-page-step]');
    if (cartPageStep) {
      event.preventDefault();
      const item = cartPageStep.closest('.cart-page-item');
      const input = item?.querySelector('input[name="updates[]"]');
      const form = cartPageStep.closest('[data-cart-page-form]');
      const update = form?.querySelector('[data-cart-page-update]');
      if (input && form && update) {
        input.value = Math.max(0, Number(input.value || 0) + Number(cartPageStep.dataset.cartPageStep));
        form.requestSubmit(update);
      }
      return;
    }
    const step = event.target.closest('[data-quantity-step]'); const remove = event.target.closest('[data-remove-line]'); if (step || remove) { event.preventDefault(); const row=(step||remove).closest('[data-cart-line]'); const input=row.querySelector('[data-line-quantity]'); const quantity=remove?0:Math.max(0,Number(input.value)+Number(step.dataset.quantityStep)); try{await updateCartLine(Number(row.dataset.cartLine),quantity);}catch(error){toast(error.message);} return; }
  });
  document.addEventListener('submit', async event => {
    const filterDrawerForm = event.target.closest('[data-filter-drawer-form]');
    if (filterDrawerForm) {
      event.preventDefault();
      const hasNativeSelection = [...filterDrawerForm.elements].some(control => {
        if (!control.name || control.disabled) return false;
        if ((control.type === 'checkbox' || control.type === 'radio')) return control.checked;
        return control.type !== 'submit' && String(control.value || '').trim() !== '';
      });
      if (hasNativeSelection) {
        const url = new URL(filterDrawerForm.action || location.pathname, location.origin);
        new FormData(filterDrawerForm).forEach((value, key) => { if (String(value).trim()) url.searchParams.append(key, value); });
        const customParams = {
          j_size: document.body.dataset.collectionSizeFilter,
          j_color: document.body.dataset.collectionColorFilter,
          j_category: document.body.dataset.collectionCategoryFilter
        };
        Object.entries(customParams).forEach(([key, value]) => { if (value) url.searchParams.set(key, value); });
        location.assign(url);
        return;
      }
      document.querySelector('[data-collection-search]')?.dispatchEvent(new Event('input', { bubbles: true }));
      closeDrawers();
      window.setTimeout(() => document.querySelector('.collection-results-head')?.scrollIntoView({ block: 'start', behavior: 'smooth' }), 80);
      return;
    }
    const form = event.target.closest('[data-product-form]'); if (!form) return; event.preventDefault(); const button=form.querySelector('[data-add-to-cart]'); if (button.disabled) return; const error=form.querySelector('[data-product-error]'); button.disabled=true; button.classList.add('loading'); error.hidden=true;
    try { const data=new FormData(form); data.append('sections','cart-drawer'); data.append('sections_url',location.pathname); const response=await fetch(`${window.Shopify?.routes?.root || '/'}cart/add.js`,{method:'POST',headers:{'Accept':'application/json'},body:data}); const result=await response.json(); if(!response.ok)throw new Error(result.description||'Izdelka ni bilo mogoče dodati.'); replaceCart(result.sections?.['cart-drawer']); await refreshCartCount(); openDrawer('cart'); }
    catch(err){error.textContent=err.message;error.hidden=false;toast(err.message);} finally{const variants=JSON.parse(form.closest('[data-product-root]').dataset.productJson||'[]');const selected=variants.find(variant=>String(variant.id)===form.querySelector('[data-variant-select]').value);button.disabled=!selected?.available;button.classList.remove('loading');}
  });
  document.addEventListener('keydown', event => { if (event.key === 'Escape') { closeMega(); closeDrawers(); } });
  document.querySelectorAll('[data-size-guide-dialog]').forEach(dialog => dialog.addEventListener('close', () => {
    document.body.style.overflow = '';
    if (sizeGuideLastFocus?.isConnected) sizeGuideLastFocus.focus();
  }));
  document.querySelectorAll('[data-legacy-measurements-source]').forEach(source => {
    const tableBody = source.parentElement?.querySelector('[data-legacy-measurements-table] tbody');
    if (!tableBody) return;
    const paragraphs = [...source.querySelectorAll('p')].map(paragraph => paragraph.textContent.replace(/\s+/g, ' ').trim());
    const startIndex = paragraphs.findIndex(line => /^MERE\s*:/i.test(line));
    if (startIndex < 0) return;
    const rows = paragraphs.slice(startIndex).map((line, index) => index === 0 ? line.replace(/^MERE\s*:\s*/i, '') : line).map(line => {
      const match = line.match(/^([^:]+):\s*(.+)$/);
      if (!match) return null;
      const valueFor = label => {
        const part = match[2].split(',').find(item => label.test(item));
        return part?.match(/\d+(?:[.,]\d+)?\s*cm/i)?.[0]?.replace(/\s*cm/i, ' cm') || '—';
      };
      return { size: match[1].trim(), waist: valueFor(/pas/i), hips: valueFor(/bok/i), length: valueFor(/dolž/i) };
    }).filter(Boolean);
    if (!rows.length) return;
    const makeCell = (tag, text, scope = '') => {
      const cell = document.createElement(tag);
      cell.textContent = text;
      if (scope) cell.scope = scope;
      return cell;
    };
    const headingRow = document.createElement('tr');
    ['VELIKOST', 'PAS', 'BOKI', 'DOLŽINA'].forEach(label => headingRow.append(makeCell('th', label, 'col')));
    const bodyRows = rows.map(row => {
      const tableRow = document.createElement('tr');
      tableRow.append(makeCell('th', row.size, 'row'), makeCell('td', row.waist), makeCell('td', row.hips), makeCell('td', row.length));
      return tableRow;
    });
    tableBody.replaceChildren(headingRow, ...bodyRows);
  });
  document.querySelectorAll('[data-wishlist-toggle]').forEach(button => { const saved=new Set(JSON.parse(localStorage.getItem('josephine-wishlist')||'[]')); const isSaved=saved.has(button.dataset.productHandle); button.textContent=isSaved?'♥':'♡'; button.classList.toggle('saved',isSaved); button.setAttribute('aria-pressed',String(isSaved)); });
  document.querySelectorAll('product-recommendations[data-url]').forEach(async element => { try { const html=await fetch(element.dataset.url).then(r=>r.text()); const doc=new DOMParser().parseFromString(html,'text/html'); const fresh=doc.querySelector('product-recommendations'); if(fresh?.innerHTML.trim())element.innerHTML=fresh.innerHTML; } catch (_) {} });

  document.querySelectorAll('[data-quick-size-filter]').forEach(grid => {
    const seen = new Set();
    grid.querySelectorAll('[data-size-filter-value]').forEach(button => {
      const value = (button.dataset.sizeFilterValue || '').trim();
      if (value && seen.has(value)) button.remove();
      else if (value) seen.add(value);
    });
  });

  const cardSupportsClothingSize = (values, selectedSizes) => {
    if (!selectedSizes.length) return true;
    const letterSizes = {
      XXS: [32, 34], XS: [34, 36], S: [36, 38], M: [38, 40], L: [40, 42],
      XL: [42, 44], XXL: [44, 46], '2XL': [44, 46], '3XL': [46, 48],
      '4XL': [48, 50], '5XL': [50, 52]
    };
    const intervalForSelection = value => {
      const numbers = (value.match(/\d+/g) || []).map(Number);
      return numbers.length ? [Math.min(...numbers), Math.max(...numbers)] : null;
    };
    const cardIntervals = values.flatMap(value => {
      const normalized = value.toUpperCase().replace(/[–—]/g, '-');
      const bodySizes = (normalized.match(/\d+/g) || []).map(Number).filter(number => number >= 30 && number <= 60);
      if (bodySizes.length) return [[Math.min(...bodySizes), Math.max(...bodySizes)]];
      if (/\bUNI(?:VERZALNA)?\b/.test(normalized)) return [[36, 46]];
      const tokens = normalized.split(/[^A-Z0-9]+/).filter(Boolean);
      return tokens.flatMap(token => letterSizes[token] ? [[Math.min(...letterSizes[token]), Math.max(...letterSizes[token])]] : []);
    });
    return selectedSizes.some(selectedSize => {
      const selectedInterval = intervalForSelection(selectedSize);
      return selectedInterval && cardIntervals.some(cardInterval => selectedInterval[0] <= cardInterval[1] && selectedInterval[1] >= cardInterval[0]);
    });
  };

  const colorAliases = {
    crna: /(?:crn|black|noir)/, bela: /(?:bel|white)/, pescena: /(?:pesc|desert)/,
    bez: /(?:bez|beige)/, rjava: /(?:rjav|brown)/, cokoladna: /(?:cokol|chocolate)/,
    fango: /fango/, siva: /(?:siv|gr[ae]y)/, modra: /(?:modr|blue|ocean|petrolej)/,
    zelena: /(?:zelen|green|kivi)/, olivna: /oliv/, roza: /(?:roza|pink|puder)/,
    malina: /(?:malin|ruby)/, bordo: /bordo/, rdeca: /(?:rdec|red)/,
    oranzna: /(?:oranz|orange|opec)/, rumena: /(?:rumen|yellow)/,
    medena: /(?:meden|gold|sampanj|karamel)/
  };
  const normalizeForFilter = value => value.normalize('NFD').replace(/[\u0300-\u036f]/g, '').toLocaleLowerCase('sl');
  const cardSupportsColor = (values, selectedColors) => {
    if (!selectedColors.length) return true;
    return selectedColors.some(selectedColor => {
      const matcher = colorAliases[selectedColor];
      return matcher ? values.some(value => matcher.test(normalizeForFilter(value))) : values.includes(selectedColor);
    });
  };

  document.querySelectorAll('[data-filter-form]').forEach(form => {
    const search = form.querySelector('[data-collection-search]');
    const count = document.querySelector('[data-collection-result-count]');
    const priceMin = document.querySelector('[data-price-min]');
    const priceMax = document.querySelector('[data-price-max]');
    const updateSearch = () => {
      const cards = [...document.querySelectorAll('.collection-grid .product-card')];
      const query = (search?.value || '').trim().toLocaleLowerCase('sl');
      const selectedSizes = (document.body.dataset.collectionSizeFilter || '').split('||').filter(Boolean);
      const selectedColors = (document.body.dataset.collectionColorFilter || '').split('||').filter(Boolean);
      const selectedCategories = (document.body.dataset.collectionCategoryFilter || '').split('||').filter(Boolean);
      const minimumPrice = Number(String(priceMin?.value || '').replace(',', '.')) * 100;
      const maximumPrice = Number(String(priceMax?.value || '').replace(',', '.')) * 100;
      let visible = 0;
      cards.forEach(card => {
        const matchesSearch = !query || card.textContent.toLocaleLowerCase('sl').includes(query);
        const cardSizes = (card.dataset.productSizes || '').split('||').filter(Boolean);
        const cardColors = (card.dataset.productColors || '').split('||').filter(Boolean);
        const cardCategories = (card.dataset.productCategories || '').split('||').filter(Boolean);
        const matchesSize = cardSupportsClothingSize(cardSizes, selectedSizes);
        const matchesColor = cardSupportsColor(cardColors, selectedColors);
        const normalizedCategories = cardCategories.map(normalizeForFilter);
        const matchesCategory = !selectedCategories.length || selectedCategories.some(category => {
          const normalizedCategory = normalizeForFilter(category);
          return normalizedCategories.some(cardCategory => cardCategory === normalizedCategory || cardCategory.includes(normalizedCategory));
        });
        const cardPrice = Number(card.dataset.productPrice || 0);
        const matchesPrice = (!Number.isFinite(minimumPrice) || !priceMin?.value || cardPrice >= minimumPrice) && (!Number.isFinite(maximumPrice) || !priceMax?.value || cardPrice <= maximumPrice);
        const matches = matchesSearch && matchesSize && matchesColor && matchesCategory && matchesPrice;
        card.hidden = !matches;
        if (matches) visible += 1;
      });
      if (count) count.textContent = (query || selectedSizes.length || selectedColors.length || selectedCategories.length || priceMin?.value || priceMax?.value) ? `${visible} prikazanih izdelkov` : `${count.dataset.total || cards.length} izdelkov`;
    };
    const currentParams = new URLSearchParams(location.search);
    const restoredFilters = {
      collectionSizeFilter: currentParams.get('j_size') || '',
      collectionColorFilter: currentParams.get('j_color') || '',
      collectionCategoryFilter: currentParams.get('j_category') || ''
    };
    Object.entries(restoredFilters).forEach(([datasetKey, value]) => { if (value) document.body.dataset[datasetKey] = value; });
    const restoreButtons = (attribute, value) => {
      const selections = new Set(value.split('||').filter(Boolean));
      document.querySelectorAll(`[${attribute}]`).forEach(button => {
        const buttonValue = (button.getAttribute(attribute) || '').trim();
        const active = buttonValue ? selections.has(buttonValue) : selections.size === 0;
        button.classList.toggle('active', active);
        button.setAttribute('aria-pressed', String(active));
      });
    };
    restoreButtons('data-size-filter-value', restoredFilters.collectionSizeFilter);
    restoreButtons('data-color-filter-value', restoredFilters.collectionColorFilter);
    restoreButtons('data-category-filter-value', restoredFilters.collectionCategoryFilter);
    if (count) count.dataset.total = count.textContent.replace(/\D/g, '') || document.querySelectorAll('.collection-grid .product-card').length;
    search?.addEventListener('input', updateSearch);
    priceMin?.addEventListener('input', updateSearch);
    priceMax?.addEventListener('input', updateSearch);
    form.addEventListener('submit', event => { if (document.activeElement === search || search?.value) { event.preventDefault(); updateSearch(); } });
    form.querySelector('[data-sort-by]')?.addEventListener('change', () => form.submit());
    if (Object.values(restoredFilters).some(Boolean)) loadAllCollectionProducts().then(updateSearch);
  });
})();


// Count Josephine proof numbers once when they enter the viewport.
const proofCounters=[...document.querySelectorAll('[data-count-to]')];
const formatProofNumber=(value,decimals=0)=>{const parts=Number(value).toFixed(decimals).split('.');parts[0]=parts[0].replace(/\B(?=(\d{3})+(?!\d))/g,'.');return parts.join(',')};
const runProofCounter=node=>{
 if(node.dataset.counted==='true')return;
 node.dataset.counted='true';
 const target=Number(node.dataset.countTo||0),decimals=Number(node.dataset.countDecimals||0);
 if(matchMedia('(prefers-reduced-motion: reduce)').matches){node.textContent=formatProofNumber(target,decimals);return}
 const duration=1800,start=performance.now();
 const frame=now=>{const progress=Math.min(1,(now-start)/duration);const eased=progress<.5?4*progress*progress*progress:1-Math.pow(-2*progress+2,3)/2;node.textContent=formatProofNumber(target*eased,decimals);if(progress<1)requestAnimationFrame(frame)};
 requestAnimationFrame(frame);
};
const proofPanel=document.querySelector('.about-proof');
const runProofSequence=()=>proofCounters.forEach((node,index)=>setTimeout(()=>runProofCounter(node),index*120));
if(proofPanel&&'IntersectionObserver' in window){const proofObserver=new IntersectionObserver(entries=>entries.forEach(entry=>{if(entry.isIntersecting){runProofSequence();proofObserver.unobserve(proofPanel)}}),{threshold:.3});proofObserver.observe(proofPanel)}else{runProofSequence()}
